<script>
    import Modal from './Modal.svelte';
	import { modal } from './stores.js';
    import PopupNewItem from './PopupNewItem.svelte';
    export let subscriptions;
</script>

<Modal show={$modal}>
    <PopupNewItem subscriptions={subscriptions} />
</Modal>